import {
  ChangeDetectorRef,
  Component,
  inject,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSort, MatSortModule, Sort } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { CommonModule } from '@angular/common';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { NewsService } from '../../../shared/services/news/news.service';
import { DeleteComponent } from '../../../shared/components/delete/delete.component';
import { CustomPipe } from '../../../shared/pipes/custom.pipe';
import { TitleComponent } from '../../../shared/components/title/title.component';
import { MailTitlePipe } from '../../../shared/pipes/mail-title.pipe';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { RolesService } from '../../../shared/services/roles/roles.service';
import { LoaderService } from '../../../shared/services/loader/loader.service';
import { LoaderComponent } from '../../../shared/components/loader/loader.component';
import { StorageService } from '../../../shared/services/storage/storage.service';
import { QeqPipe } from 'src/app/shared/pipes/qeq-pipe/qeq-pippe.pipe';

@Component({
  selector: 'app-mailbox',
  imports: [
    MatIcon,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatTableModule,
    MatSortModule,
    CommonModule,
    MatDialogModule,
    MatMenuModule,
    MatPaginatorModule,
    MatTabsModule,
    MatDatepickerModule,
    MatInputModule,
    CustomPipe,
    TitleComponent,
    MailTitlePipe,
    RouterOutlet,
    LoaderComponent,
    QeqPipe,
  ],
  templateUrl: './mailbox.component.html',
  styleUrls: ['./mailbox.component.css', '../../../shared/styles/layout.css'],
})
export class MailboxComponent implements OnDestroy {
  title: string = 'Buzón';
  subtitle: string = 'Gestiona las consultas de los empleados.';

  // Store subscriptions for cleanup
  private subscriptions: Subscription[] = [];
  private navigationSubscription: Subscription | null = null;

  toppings = new FormControl<string[]>([]);
  toppingList: string[] = ['Iniciada', 'En trámite', 'Aceptada', 'Declinada'];
  statusMap: { [key: string]: string } = {
    Iniciada: 'Iniciada',
    'En trámite': 'En trámite',
    Aceptada: 'Aceptada',
    Declinada: 'Declinada',
  };

  get isLoading() {
    return this.loaderService.getLoader();
  }

  constructor(
    private newsService: NewsService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private rolesService: RolesService,
    private loaderService: LoaderService,
    private storageService: StorageService
  ) {}

  selectedFilter: string = 'todo';

  filters = [
    { value: 'mes', label: 'Mes' },
    { value: 'semana', label: 'Últimos 7 días' },
    { value: 'hoy', label: 'Hoy' },
    { value: 'todo', label: 'Todo' },
  ];

  selectFilter(filter: string) {
    // console.debug(
    //   `Filter selected: ${filter} (previous: ${this.selectedFilter})`
    // );
    this.selectedFilter = filter;
    this.applyFilters();
  }

  // Helper methods for date filtering
  private getStartDateForFilter(filter: string): Date | null {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Start of today

    switch (filter) {
      case 'mes':
        const monthStart = new Date(today);
        monthStart.setDate(1); // First day of current month
        return monthStart;

      case 'semana':
        const weekStart = new Date(today);
        weekStart.setDate(today.getDate() - 6); // 7 days ago (including today)
        return weekStart;

      case 'hoy':
        return today;

      case 'todo':
      default:
        return null; // No date filtering
    }
  }

  // Method to apply both status and date filters
  applyFilters() {
    const selectedStatuses = this.toppings.value || [];
    const startDate = this.getStartDateForFilter(this.selectedFilter);

    const filterValue = JSON.stringify({
      statusFilter: selectedStatuses,
      dateFilter: startDate ? startDate.getTime() : null, // Convert to timestamp for comparison
    });
    this.dataSource.filter = filterValue;
  }

  readonly dialog = inject(MatDialog);

  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();

  private _liveAnnouncer = inject(LiveAnnouncer);

  displayedColumns: string[] = [
    'title',
    'author',
    'id',
    'status',
    'types',
    'send-date',
    'updated-status-date',
    'acciones',
  ];

  @ViewChild(MatSort)
  sort: MatSort = new MatSort();

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.setupCustomSorting();
  }

  announceSortChange(sortState: Sort) {
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }

  deleteSelected(id: number, nick: string) {
    const dialogRef = this.dialog.open(DeleteComponent, {
      width: '550px',
      data: {
        title: '¿Seguro que quieres eliminar esta consulta?',
        message: nick,
        confirmText: 'Eliminar',
        cancelText: 'Cancelar',
        handler: () => {
          return this.newsService.deleteMailbox(id);
        },
      },
    });

    // Esperar a que el diálogo se cierre y actualizar la tabla
    dialogRef.afterClosed().subscribe((confirmed) => {
      if (confirmed) {
        this.newsService.refreshPendingSuggestions();
        this.dataSource.data = this.dataSource.data.filter(
          (user) => user.id !== id
        );
      }
    });
  }
  myroles: any = {}; // Change from array to object

  ngOnInit() {
    this.loaderService.showLoader();

    // Set initial filter state
    this.selectedFilter = 'todo'; // Reset to default filter

    // Setup navigation listener
    this.setupNavigationListener();

    // Load roles and mailbox data
    this.loadRoles();
    this.loadMailboxData();

    // Setup filter subscriptions
    this.setupFilterSubscriptions();
  }

  setupNavigationListener() {
    // Clean up existing navigation subscription if it exists
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }

    // Set up new navigation subscription
    this.navigationSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        if (
          this.router.url.includes('/communication/mailbox/edit') ||
          this.router.url.includes('/communication/mailbox/add')
        ) {
          this.isUuid = true;
        } else if (this.router.url.includes('/communication/mailbox')) {
          this.isUuid = false;

          // Clear existing subscriptions before reloading data
          this.clearSubscriptions();

          // Set initial filter state
          this.selectedFilter = 'todo'; // Reset to default filter

          // Reload data
          this.loadRoles();
          this.loadMailboxData();
          this.setupFilterSubscriptions();
        }

        this.cdr.detectChanges();
      });
  }

  loadRoles() {
    // Use the refactored method in RolesService
    const permissions = this.rolesService.getPermissionsForFunctionality(
      'inbox',
      this.storageService
    );
    if (permissions) {
      this.myroles = permissions;
    } else {
      // console.log(
      //   'No user roles found in storage or no permissions for Comunicación'
      // );
    }
  }

  loadMailboxData() {
    const mailboxSub = this.newsService.getSuggestions().subscribe({
      next: (suggestions) => {
        let filteredSuggestions = suggestions.sort((a, b) => {
          const dateA = a.created_when
            ? new Date(a.created_when).getTime()
            : a.updated_at
            ? new Date(a.updated_at).getTime()
            : 0;
          const dateB = b.created_when
            ? new Date(b.created_when).getTime()
            : b.updated_at
            ? new Date(b.updated_at).getTime()
            : 0;
          return dateB - dateA; // Descending order (most recent first)
        });
        // console.debug('filtered suggestions', filteredSuggestions);
        this.dataSource = new MatTableDataSource(filteredSuggestions);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

        // Set up the filter predicate and custom sorting after creating a new data source
        this.setupFilterPredicate();
        this.setupCustomSorting();

        // Apply initial filters if needed
        this.applyFilters();

        this.loaderService.hideLoader();
      },
      error: (error) => {
        console.error('Error fetching suggestions:', error);
        this.loaderService.hideLoader();
      },
    });

    this.subscriptions.push(mailboxSub);
  }

  setupFilterSubscriptions() {
    // Subscribe to changes in the toppings control
    const toppingsSub = this.toppings.valueChanges.subscribe(
      (selectedStatuses) => {
        // Apply the filter
        this.applyFilters();
      }
    );

    this.subscriptions.push(toppingsSub);
  }

  clearSubscriptions() {
    // Unsubscribe from all subscriptions
    this.subscriptions.forEach((sub) => {
      if (sub && !sub.closed) {
        sub.unsubscribe();
      }
    });

    // Reset the subscriptions array
    this.subscriptions = [];
  }

  ngOnDestroy() {
    // Clean up all subscriptions when component is destroyed
    this.clearSubscriptions();

    // Also clean up navigation subscription if it exists
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
      this.navigationSubscription = null;
    }
  }

  // Replace the existing applyStatusFilter with this more comprehensive method
  applyStatusFilter(selectedStatusValues: string[]) {
    this.applyFilters();
  }

  isUuid: boolean = false;
  goToMail(id: number) {
    this.router.navigate(['home/communication/mailbox/edit', id]);
    this.isUuid = true;
  }

  addMail() {
    this.router.navigate(['home/communication/mailbox/add']);
    this.isUuid = true;
  }

  // Set up the filter predicate for the data source
  private setupFilterPredicate() {
    this.dataSource.filterPredicate = (data, filter) => {
      try {
        const filterObj = JSON.parse(filter);
        let passesStatusFilter = true;
        let passesDateFilter = true;

        // Status filtering
        if (filterObj.statusFilter && filterObj.statusFilter.length > 0) {
          passesStatusFilter = filterObj.statusFilter.includes(data.status);
        }

        // Date filtering
        if (filterObj.dateFilter) {
          // Parse the created_when date to a timestamp
          const createdWhen = new Date(data.created_when).getTime();
          // Check if the item's date is after or equal to the filter date
          passesDateFilter = createdWhen >= filterObj.dateFilter;

          // // Debug date comparison
          // if (!passesDateFilter) {
          //   // console.debug('Filtered out by date:', {
          //   //   itemDate: new Date(data.created_when).toISOString(),
          //   //   itemTimestamp: createdWhen,
          //   //   filterTimestamp: filterObj.dateFilter,
          //   //   filterDate: new Date(filterObj.dateFilter).toISOString(),
          //   // });
          // }
        }

        const passes = passesStatusFilter && passesDateFilter;
        return passes;
      } catch (error) {
        console.error('Error applying filter:', error);
        return true; // In case of error, show the row
      }
    };
  }

  // Set up custom sort functions for date and status columns
  private setupCustomSorting() {
    // Create custom sorting function for sorting dates and status
    this.dataSource.sortingDataAccessor = (item: any, property: string) => {
      switch (property) {
        case 'send-date':
          // Sort by the original date value (created_when) with safe fallback
          return item.created_when
            ? new Date(item.created_when).getTime()
            : item.updated_at
            ? new Date(item.updated_at).getTime()
            : 0;
        case 'updated-status-date':
          // Sort by the original date value (updated_at) with safe fallback
          return item.updated_at ? new Date(item.updated_at).getTime() : 0;
        case 'status':
          // Custom sort order for status: Iniciada, En trámite, Aceptada, Declinada
          const statusOrder: { [key: string]: number } = {
            Iniciada: 1,
            'En trámite': 2,
            Aceptada: 3,
            Declinada: 4,
          };
          const status = item.status as string;
          return statusOrder[status] || 999; // Default high number for unknown status
        default:
          return item[property];
      }
    };
  }
}
